import { TextField } from 'material-ui';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

function BasicInput({ 
    value,
    onChange,
    floatingLabelStyle = {}, 
    style = {},
    underlineStyle = {},
    name,
    type,
    onBlur = () => {},
    disabled = false,
    placeholder = '',
    onFocus = () => {},
}) {
    return (
        <TextField 
            name={name + uuidv4()}
            value={value || ''}
            onChange={onChange}
            floatingLabelStyle={floatingLabelStyle}
            style={{ width: '100%', ...style }}
            underlineStyle={underlineStyle}
            type={type}
            onBlur={onBlur}
            disabled={disabled}
            placeholder={placeholder}
            onFocus={onFocus}
        />
    );
}

export default React.memo(BasicInput);



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicInput.jsx